"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonPriceManagerContractConnector = void 0;
const TonPriceManagerContractAdapter_1 = require("./TonPriceManagerContractAdapter");
const TonPriceManager_1 = require("../../wrappers/TonPriceManager");
const TonContractConnector_1 = require("../TonContractConnector");
class TonPriceManagerContractConnector extends TonContractConnector_1.TonContractConnector {
    constructor(network, address) {
        super(TonPriceManager_1.TonPriceManager, network, address);
    }
    async getAdapter() {
        return new TonPriceManagerContractAdapter_1.TonPriceManagerContractAdapter(await this.getContract());
    }
}
exports.TonPriceManagerContractConnector = TonPriceManagerContractConnector;
//# sourceMappingURL=TonPriceManagerContractConnector.js.map